import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { locationSearch, routerCustomerId, routerAppName } from '../helpers/utils';
import { getBrowserId } from '../services/storage/launchStorage';
import { getSingleUseLaunch } from '../services/http/browserRequest';
import { IPolicyModel } from '../interface/IIcafile.interface';
import { ISingleUseLaunchResponse } from '../interface/ISingleUseLaunch.interface'
import { CurrentComponentEnum } from '../enums/currentComponent';
import ErrorComponent from '../components/error/error';
import ProgressComponent from '../components/progress/progress';
import SessionComponent from '../components/session/session';
import { ErrorCodeEnum } from '../enums/errorCode';

const ProxyContainer = () => {
    const [activeComponent, setActiveComponent] = useState(CurrentComponentEnum.Progress);
    const [appName, setAppName] = useState(routerAppName);
    const [appIcon, setAppIcon] = useState('');
    const [icaFile, setIcaFile] = useState('');
    const [icaData, setIcaData] = useState('');
    const [icaPolicies, setIcaPolicies] = useState({} as IPolicyModel);
    const [errorCode, setErrorCode] = useState(ErrorCodeEnum.Default);

    const initViewport = {
        width: window.innerWidth,
        height: window.innerHeight
    }

    useEffect(() => {
        init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const init = () => {
        const ticket = locationSearch('ticket');
        const fastLaunch = locationSearch('fastLaunch');

        if (!ticket) {
            setActiveComponent(CurrentComponentEnum.Error);
        } else {
            setActiveComponent(CurrentComponentEnum.Progress);
            getSingleUseLaunch(routerCustomerId, ticket, fastLaunch !== "false", getBrowserId())
                .then((response: ISingleUseLaunchResponse) => {
                    setAppName(response?.launchInfo?.friendlyName || '');
                    setAppIcon(response.launchInfo.icon || '');
                    setIcaFile(response.launch.icaFile);
                    response?.launchInfo?.policies && setIcaPolicies(response.launchInfo.policies);
                    setIcaData(response.launch.icaData || '');
                    setActiveComponent(CurrentComponentEnum.Session);
                }).catch(error => {
                    setActiveComponent(CurrentComponentEnum.Error);

                    if (activeComponent === CurrentComponentEnum.Progress) {
                        const response = error.data ;
                        if (response && response.parameters) {
                            const catalogsError = response.parameters.filter((p: any) => p.name === 'reason');
                            if (catalogsError.length !== 0) {
                                setActiveComponent(CurrentComponentEnum.Error);
                                if (response.parameters[0].value === 'noCatalogsDefined') {
                                    setErrorCode(ErrorCodeEnum.ResourceNotFound)
                                }
                            }
                        }
                    } else {
                        setErrorCode(ErrorCodeEnum.ResourceProviderUnreachable)
                    }
                });
        }
    }

    return (
        <div className="proxy-page-container" data-testid='proxy-page'>
            <Helmet>
                <title>{ appName }</title>
                <link rel="icon" href={ appIcon } />
            </Helmet>
            { activeComponent === CurrentComponentEnum.Progress && <ProgressComponent/> }
            { activeComponent === CurrentComponentEnum.Session &&
                <SessionComponent
                    icaFile={ icaFile }
                    icaData={ icaData }
                    icaPolicies={ icaPolicies }
                    initViewport={ initViewport }
                /> }
            { activeComponent === CurrentComponentEnum.Error && <ErrorComponent errorCode={ errorCode }/> }

        </div>
    )
   
}

export default ProxyContainer;